import { render, staticRenderFns } from "./AddTeamConfig.vue?vue&type=template&id=4d79849c&"
import script from "./AddTeamConfig.vue?vue&type=script&lang=js&"
export * from "./AddTeamConfig.vue?vue&type=script&lang=js&"
import style0 from "./AddTeamConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports